import { ActionType } from '../reducers/genericPages';
import { api } from '../config';
import mockData from '../mocks/genericPages.json';

export const getGenericPagesData = (endPointName: string) => {
  return (dispatch) => {
    const shouldFetchMock = false;
    const fetchType = shouldFetchMock ? 'FETCH_MOCK' : 'FETCH';
    const mockResult = mockData;

    const url = `${api.genericPages}/${endPointName}`;
    const method = 'get';

    const type: ActionType = 'SET_GENERIC_PAGES_DATA';
    return Promise.resolve(
      dispatch({
        type,
        fetch: {
          type: fetchType,
          actionTypes: {
            request: 'REQUEST_GENERIC_PAGES_DATA',
            success: 'RECEIVED_GENERIC_PAGES_DATA',
            fail: 'ERROR_GENERIC_PAGES_DATA',
          },
          url,
          // props only used when type = FETCH_MOCK:
          mockResult,
          method,
        },
      }),
    );
  };
};
